// React Imports
import type { SVGAttributes } from 'react';

export const IceLogo = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="57" height="52" viewBox="0 0 57 52" fill="none" {...props}>
      <g clipPath="url(#clip0_355_60825)">
        <path d="M7.66397 0.473389H0.396484V51.1569H7.66397V0.473389Z" fill="black" />
        <path
          d="M56.3373 0.440918V7.92289H34.5474C32.4731 7.92289 30.7948 6.23545 30.8067 4.16114C30.8181 2.10333 32.4896 0.440918 34.5474 0.440918H56.3373Z"
          fill="black"
        />
        <path
          d="M56.3373 43.7097V51.1917H34.5474C32.4731 51.1917 30.7948 49.5042 30.8067 47.4299C30.8181 45.3721 32.4896 43.7097 34.5474 43.7097H56.3373Z"
          fill="black"
        />
        <path
          d="M31.8094 51.1097C28.0551 50.8093 24.5311 49.6919 21.4157 47.9351C19.4899 46.8502 17.7205 45.52 16.1486 43.9879C11.4196 39.3784 8.4834 32.9393 8.4834 25.8141C8.4834 22.8875 8.97893 20.0758 9.89093 17.4605C10.1196 16.8022 10.3751 16.1571 10.6556 15.525C14.1772 7.59528 21.6433 1.80644 30.5629 0.648669C30.997 0.592345 31.4345 0.546831 31.8754 0.512695C31.2587 0.84438 30.7376 1.35528 30.3695 1.98394C30.002 2.61261 29.7869 3.3579 29.7829 4.15895C29.7767 5.3116 30.2085 6.35501 30.9066 7.10145C31.2644 7.48434 31.6917 7.78871 32.1667 7.99068C29.1406 8.22622 26.3255 9.21501 23.9099 10.7699C18.9676 13.9508 15.6946 19.5001 15.6946 25.8141C15.6946 30.8599 17.7854 35.417 21.1472 38.6684C22.2185 39.7044 23.4195 40.6073 24.7229 41.3509C26.6635 42.4592 28.8317 43.2136 31.1404 43.5276C31.4999 43.5771 31.8629 43.6152 32.2287 43.6425C30.8076 44.2149 29.7915 45.7038 29.7829 47.4544C29.7744 49.0451 30.5999 50.427 31.8094 51.1097Z"
          fill="url(#paint0_linear_355_60825)"
        />
        <path
          d="M31.4112 50.9959C27.906 50.7154 24.6017 49.7227 21.6432 48.1627C19.7174 47.0777 17.948 45.7476 16.3761 44.2154C11.9732 39.924 9.12455 34.0464 8.75304 27.5055C8.72516 27.0213 8.71094 26.5332 8.71094 26.0416C8.71094 23.3802 9.12057 20.8137 9.88122 18.4037C9.95689 18.1637 10.036 17.9247 10.1185 17.688C10.3472 17.0298 10.6026 16.3846 10.8831 15.7525C10.9138 15.6837 10.9445 15.6149 10.9758 15.546C12.0961 13.0843 13.5975 10.8325 15.4049 8.86738C19.3419 4.58677 24.7308 1.66248 30.7905 0.876221C30.4702 1.15556 30.1931 1.49123 29.9712 1.87014C29.6037 2.4988 29.3886 3.2441 29.3846 4.04515C29.3784 5.1978 29.8102 6.24121 30.5083 6.98764C30.8661 7.37053 31.2934 7.67491 31.7684 7.87688C28.7423 8.11241 25.9273 9.10121 23.5116 10.6561C22.5114 11.3001 21.5789 12.0409 20.729 12.8658C18.7281 14.8058 17.1794 17.2101 16.2566 19.9051C15.9119 20.9116 15.6541 21.9584 15.4931 23.0371C15.3634 23.9058 15.2963 24.7951 15.2963 25.7002C15.2963 28.8305 16.1013 31.773 17.5151 34.332C18.3799 35.8983 19.4728 37.3206 20.7489 38.5546C21.9897 39.7545 23.4041 40.7757 24.9504 41.5785C26.891 42.6867 29.0592 43.4411 31.3679 43.7552C30.1937 44.4385 29.392 45.7862 29.3846 47.3405C29.3761 48.9313 30.2016 50.3132 31.4112 50.9959Z"
          fill="url(#paint1_linear_355_60825)"
        />
        <path
          d="M56.3196 22.0142V29.5837H32.7074C30.6086 29.5837 28.911 27.8764 28.9229 25.7776C28.9343 23.6953 30.6257 22.0142 32.7074 22.0142H56.3196Z"
          fill="black"
        />
        <path
          d="M17.5151 34.3318L17.3154 34.5736L8.75304 27.5053C8.72516 27.0211 8.71094 26.533 8.71094 26.0414C8.71094 23.38 9.12057 20.8135 9.88122 18.4036L15.4931 23.0369C15.3634 23.9057 15.2963 24.7949 15.2963 25.7001C15.2963 28.8303 16.1013 31.7728 17.5151 34.3318Z"
          fill="url(#paint2_linear_355_60825)"
        />
        <path
          opacity="0.29"
          d="M20.7292 12.8656C18.7283 14.8057 17.1797 17.2099 16.2569 19.905L10.9761 15.5458C12.0963 13.0841 13.5977 10.8323 15.4052 8.86719L20.7292 12.8656Z"
          fill="url(#paint3_linear_355_60825)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_355_60825"
          x1="15.0181"
          y1="42.5656"
          x2="37.3405"
          y2="8.29221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEA339" />
          <stop offset="0.25" stopColor="#F6C16D" />
          <stop offset="0.47" stopColor="#FEDE9E" />
          <stop offset="1" stopColor="#FDC767" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_355_60825"
          x1="14.9373"
          y1="42.615"
          x2="36.8524"
          y2="8.96751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3720F" />
          <stop offset="0.05" stopColor="#C4801B" />
          <stop offset="0.14" stopColor="#EEA339" />
          <stop offset="0.25" stopColor="#F6C16D" />
          <stop offset="0.34" stopColor="#FEDE9E" />
          <stop offset="0.64" stopColor="#FDC767" />
          <stop offset="1" stopColor="#DB9044" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_355_60825"
          x1="10.6174"
          y1="18.044"
          x2="16.1645"
          y2="44.6681"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.03" stopColor="#FFFFBB" />
          <stop offset="0.23" stopColor="#FEDE9E" />
          <stop offset="0.71" stopColor="#FDC767" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_355_60825"
          x1="14.6001"
          y1="18.8615"
          x2="21.3647"
          y2="-6.27995"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.03" stopColor="#FFFFBB" />
          <stop offset="0.23" stopColor="#FEDE9E" />
          <stop offset="0.71" stopColor="#FDC767" stopOpacity="0.1" />
        </linearGradient>
        <clipPath id="clip0_355_60825">
          <rect width="56.8928" height="52" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
